import React from 'react';
import "./App.css";
import MainGrid from "./MainGrid";
import LogoutIcon from '@mui/icons-material/Logout';
import IconButton from '@mui/material/IconButton';
import firebase from "./base.js";

function DashBoard() {
	return (
		<div className="dashboard">
			
			<div className='dashboard_head dash_row'>
				<h4>The Chartistt Bot</h4>

				<div className='dash_row'>
					
					<IconButton onClick={()=>firebase.auth().signOut()}>
						<LogoutIcon color="error" />
					</IconButton>
					
				</div>
			</div>
			
			<MainGrid />

		

			
		</div>
	)
}

export default DashBoard